import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from 'src/infra/stores/store';
import { envConfig } from 'src/config/config';

export interface ApiVersionState {
  useV2: boolean;
}

// Get default API version from environment variable (1 or 2)
const getDefaultApiVersion = (): boolean => {
  const defaultVersion = envConfig.defaultApiVersion;
  return defaultVersion === '2';
};

const initialState: ApiVersionState = {
  useV2: getDefaultApiVersion(),
};

export const apiVersionSlice = createSlice({
  name: 'apiVersion',
  initialState,
  reducers: {
    setApiVersion: (state, action: PayloadAction<boolean>) => {
      state.useV2 = action.payload;
    },
  },
});

export const { setApiVersion } = apiVersionSlice.actions;

export const selectApiVersion = (state: IRootState) => state.apiVersion.useV2;

export default apiVersionSlice.reducer;
